import axios from 'axios';
export function createCEOOnboardingApi({ endpoints = {}, sessionToken } = {}) {
  const base = process.env.REACT_APP_SERVER_SCRIPT_HOST;
  const headers = sessionToken ? { Authorization: `Bearer ${sessionToken}` } : {};
  const send = async (url, payload) => (await axios.post(url, payload, { headers, timeout: 30000 })).data;
  return {
    loadPlans: base || endpoints.plans ? async ({ signal }) => {
      const { data } = await axios.get(endpoints.plans || `${base}/company_features/get_plans`, { headers, signal, timeout: 30000 });
      return data.companyPlans || [];
    } : undefined,
    checkEmail: base || endpoints.checkClientEmail || endpoints.checkStaffEmail ? async ({ kind, email }) => {
      const url = kind === 'client' ? endpoints.checkClientEmail || (base && `${base}/new_client/register/checkExist`) : endpoints.checkStaffEmail || (base && `${base}/universe-staff/register/checkExist`);
      if (!url) throw new Error('Email check is not connected.');
      const { data } = await axios.get(`${url}/${encodeURIComponent(email)}`, { headers, timeout: 30000 });
      if (Number(data.status) !== 201) throw new Error(data.message || 'This email cannot be registered.');
      return data;
    } : undefined,
    onCreateClient: endpoints.createClient ? payload => send(endpoints.createClient, payload) : undefined,
    onCreateStaff: endpoints.createStaff ? payload => {
      const url = typeof endpoints.createStaff === 'string' ? endpoints.createStaff : endpoints.createStaff[payload.staffData.role.name];
      if (!url) throw new Error('This staff role is not connected to a registration endpoint.');
      return send(url, payload);
    } : undefined,
  };
}
